import type en from "../en/credits";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  wallet: "Portefeuille",
  subtitle: "Achetez des crédits selon vos besoins. Aucun forfait mensuel.",
  available: "Disponible",
  credits: "crédits",
  creditsCount: "{n} crédits",
  creditsCount_one: "{n} crédit",
  purchased: "Achetés",
  spent: "Dépensés",
  lowBalance: "Solde faible. Veuillez ajouter des crédits.",
  addCredit: "Ajouter des crédits",
  addCreditDescription: "Choisissez un pack. Les crédits n’expirent pas et servent pour toutes vos boutiques.",
  noPacks: "Aucun pack de crédits n’est disponible pour le moment.",
  noPacksDescription: "Contactez le support si vous avez besoin de crédits.",
  popular: "★ Le plus populaire",
  bestValue: "💎 Meilleure offre",
  bonusLine: "+{bonus} bonus · {percent} %",
  totalCreditsSr: "{n} crédits au total",
  selectPack: "Choisir le pack {label}",
  summary: "{price} = {credits} crédits",
  summaryBonus: "{price} = {credits} crédits (dont {bonus} de bonus)",
  buy: "Acheter des crédits",
  redirecting: "Ouverture du paiement sécurisé…",
  securePayment: "Paiement sécurisé par Stripe. Les crédits sont ajoutés dès la confirmation du paiement.",
  purchaseUnavailable: "L’achat en ligne n’est pas encore disponible — contactez le support pour ajouter des crédits.",
  contactSupport: "Contacter le support",
  choosePack: "Choisissez un pack de crédits.",
  successTitle: "Paiement reçu",
  successBody: "Vos crédits ont été ajoutés à votre portefeuille.",
  pendingTitle: "Paiement en cours de confirmation…",
  pendingBody: "Vos crédits apparaîtront ici dès que le paiement sera validé. Vous pouvez actualiser la page dans un instant.",
  problemBody: "Nous n’avons pas pu confirmer ce paiement automatiquement. Si vous avez été débité, contactez le support.",
  cancelled: "Le paiement a été annulé. Aucun montant n’a été prélevé.",
  thisMonth: "Ce mois-ci",
  planIncludes: "Votre forfait {plan} inclut un quota mensuel gratuit. Au-delà, l’utilisation est payée en crédits.",
  usagePrompts: "Requêtes IA",
  usageCallMinutes: "Minutes d’appel vocal",
  usageImages: "Images IA",
  usedThisMonth: "{used} utilisés ce mois-ci",
  unlimitedFree: "Illimité (gratuit)",
  freeForEveryone: "Gratuit pour tous actuellement — aucun crédit n’est utilisé.",
  pricing: "Ce que coûtent les actions",
  costPrompt: "Requête IA",
  costPromptHint: "en qualité Moyenne",
  costCall: "Appel vocal, par minute",
  costImage: "Image IA",
  costTranslation: "Traduction IA, par élément",
  free: "Gratuit",
  levels: "Niveaux de qualité",
  levelsHint: "Les requêtes et appels coûtent plus cher aux niveaux de qualité supérieurs.",
  level_low: "Bas",
  level_medium: "Moyen",
  level_high: "Élevé",
  level_max: "Max",
  multiplier: "×{n}",
  notOnPlan: "Non inclus dans votre forfait",
  history: "Historique",
  historyDescription: "Vos 50 derniers mouvements de crédits.",
  noHistory: "Aucune activité pour l’instant",
  noHistoryDescription: "Les achats et l’utilisation de l’IA apparaîtront ici.",
  colDescription: "Description",
  colCredits: "Crédits",
  colBalance: "Solde après",
  kind_signup: "Crédits de bienvenue",
  kind_purchase: "Achat de crédits",
  kind_spend: "Utilisation de l’IA",
  kind_refund: "Remboursement",
  kind_admin: "Ajustement par la plateforme",
  feature_prompt: "Requête IA",
  feature_call: "Appel vocal",
  feature_image: "Image IA",
  feature_translation: "Traduction IA",
  chipLabel: "Crédits IA : {count}. Ouvrir le portefeuille",
  chipLowLabel: "Crédits IA faibles : {count}. Ajouter des crédits",
  bannerLow: "⚡ Plus que {n} crédits — rechargez pour continuer à créer",
  bannerLow_one: "⚡ Plus que {n} crédit — rechargez pour continuer à créer",
  bannerEmpty: "Vous n’avez plus de crédits — ajoutez-en pour continuer",
  bannerCta: "Ajouter des crédits →",
  dismiss: "Masquer",
};

export default fr;
